module.exports = __webpack_public_path__ + "static/media/kid_avatar_02.2044fac1.png";